import type { OrganizationMember, TeamMember } from '~/types';

/**
 * Get display name for a member, falling back to email or "Unknown".
 */
export function getDisplayName(member: TeamMember | OrganizationMember): string {
  return member.name || member.email || 'Unknown';
}
